import styled from 'styled-components';
import { color } from 'styles/pallete';

export const container = styled.div`
	position: sticky;
	top: 0;
	width: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	box-sizing: border-box;
	background-color: ${color.interface.lightGray4};
	padding-top: 2rem;
	padding-bottom: 1.5rem;
	z-index: 10;
	@media (max-width: 1000px) {
		height: 70px;
		position: fixed;
		top: 0;
		left: 0;
		padding: 2rem 2.4rem;
		/* padding-bottom: 0rem;
		padding-left: 2.4rem;
		padding-right: 2.4rem; */
		-webkit-box-shadow: 0px -3px 15px 7px rgba(0, 0, 0, 0.09);
		box-shadow: 0px -3px 15px 7px rgba(0, 0, 0, 0.09);
	}
`;

export const title = styled.div`
	display: flex;
	flex-direction: column;
	> p {
		font-size: 1.7rem;
		color: ${color.interface.darkgray3};
		font-weight: 900;
		font-family: nunito-bold;
	}
	> label {
		font-size: 1.3rem;
		color: ${color.interface.darkgray3};
		opacity: 0.8;
	}
`;

export const logoWithMenu = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;

	img {
		transform: translateY(-15%);
		width: 80px;
	}
`;

export const options = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 1.5rem;
`;

export const optionsModal = styled.div``;
